import { useTranslation } from 'react-i18next';
import { VideoCameraIcon, CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import AvatarExamples from './AvatarExamples';

export default function AvatarVideoGuide() {
  const { t } = useTranslation('avatar');

  const requirements = [
    { text: t('avatar:guide.req1', '不要使用有多个人脸出现的视频'), pass: false },
    { text: t('avatar:guide.req2', '确保人脸占比不要过大或过小，确保整张人脸都在屏幕区域内，人脸不要出屏幕, 建议人脸宽度占整体画面宽度的十分之一至三分之一'), pass: true },
    { text: t('avatar:guide.req3', '确保面部特征未被遮挡，使五官和面部轮廓清晰可见'), pass: true },
    { text: t('avatar:guide.req4', '上传的视频分辨率建议为720P或1080P，最大分辨率不超过4K'), pass: true },
    { text: t('avatar:guide.req5', '视频时长不少于3秒，不超过5分钟（3s-5min）'), pass: true },
    { text: t('avatar:guide.req6', '为了获取更好的口型生成效果, 建议使用正常讲话的人物视频, 视频中音频和嘴唇运动必须同步, 避免环境噪音或其他声音（除了讲话声）。保持适度的语速，语速过慢可能会降低嘴唇同步精度，语速过快可能会导致嘴唇同步抖动。'), pass: true },
  ];

  return (
    <div className="bg-bg-surface border border-border-subtle rounded-2xl p-6">
      {/* Header */}
      <div className="flex items-center gap-2 mb-5">
        <VideoCameraIcon className="w-5 h-5 text-primary" />
        <h3 className="text-gray-50 font-semibold text-lg">
          {t('avatar:guide.requirementsTitle', '原始素材要求')}
        </h3>
      </div>

      {/* Landscape Layout: Left = Requirements, Right = Examples */}
      <div className="flex flex-col lg:flex-row gap-6">
        {/* Left Column - Requirements */}
        <div className="flex-1 space-y-2.5">
          {requirements.map((req, index) => (
            <div key={index} className="flex items-start gap-2.5">
              {req.pass ? (
                <CheckCircleIcon className="w-4 h-4 text-green-400 flex-shrink-0 mt-0.5" />
              ) : (
                <XCircleIcon className="w-4 h-4 text-red-400 flex-shrink-0 mt-0.5" />
              )}
              <p className={`text-sm leading-relaxed ${req.pass ? 'text-gray-300' : 'text-red-300'}`}>
                {req.text}
              </p>
            </div>
          ))}
        </div>

        {/* Right Column - Examples */}
        <div className="w-full lg:w-auto lg:min-w-[360px] flex-shrink-0">
          <AvatarExamples />
        </div>
      </div>
    </div>
  );
}
